import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-hot-toast';

import { cleanActionSelectedPreRegister, getAllPreRegister } from '../../redux/actions/preRegistration';

import { ContainerFull } from '../../components/ContainerFull';
import { Heading } from '../../components/Heading';
import { Wrapper } from '../../components/Wrapper';

import { capitalizarPalabras } from '../../common/upperCaseWord';
import { formatDate } from '../../common/formatDateText';
import { exportToExcel } from '../../common/importDataToExcel';
import { verifyStateApp } from '../../redux/actions/stateApp';
import { Loading } from '../../components/loading/Loading';
import {
	EyeIcon,
	CheckCircleIcon
} from '@heroicons/react/20/solid';
import { Tooltip, Zoom } from '@mui/material';
import { DataTableCustom } from '../../components/dataTable/DataTableCustom';
import { DropDownFilterSingle } from '../../components/dropDown/DropDownFilterSingle';
import { optionsStatusCandidate } from '../../static/data';

function classNames(...classes) {
	return classes.filter(Boolean).join(' ')
}

export const CandidatesPage = () => {
	const dispatch = useDispatch();

	const {
		allPreRegisters,
		loading,
	} = useSelector((state) => state.preRegistration);
	const timeoutRef = useRef(null);
	const [filterOption, setFilterOption] = useState("");
	const [rows, setRows] = useState([]);
	const { user } = useSelector((state) => state.user);

	const { _id: id, roles, typeUser } = user;


	const typeUserCanValidate = ['coordinador', 'director', 'ventas'];
	const typeUserCanView = ['cobranza', 'subdirector', 'control escolar'];
	const [searchText, setSearchText] = useState('');
	const [pageSizeOptions, setpageSizeOptions] = useState({
		pageSize: 15,
		page: 0,
		totalRows: 0
	});

	useEffect(() => {
		setRows(allPreRegisters);
	}, [allPreRegisters]);

	useEffect(() => {
		dispatch(cleanActionSelectedPreRegister())
	}, [dispatch]);


	useEffect(() => {
		dispatch(getAllPreRegister(
			id,
			roles,
			pageSizeOptions.page,
			pageSizeOptions.pageSize,
			filterOption,
			searchText // Aquí puedes agregar más filtros si es necesario,
		)).then(((result) => {
			if (result.status === 200) {
				setpageSizeOptions({
					pageSize: result.pageSize,
					page: result.page,
					totalRows: result.totalRows
				})
			}
		}
		));
	}, [id, roles, filterOption, dispatch]);


	const handlePageChange = (model) => {
		setpageSizeOptions(model);
		dispatch(getAllPreRegister(
			id,
			roles,
			model.page,
			model.pageSize,
			filterOption,
			searchText // Aquí puedes agregar más filtros si es necesario
		))
			.then(((result) => {
				console.log(result)
				if (result.status === 200) {
					setpageSizeOptions({
						pageSize: result.pageSize,
						page: result.page,
						totalRows: result.totalRows
					})
				}
			}
			));
	}

	const columns = [
		{
			field: 'status',
			headerName: 'Estatus',
			width: 180,
			renderCell: (params) => (
				<div className='w-full flex justify-center'>
					<div className={classNames(
						params.value === 'completado'
							? 'bg-emerald-100 text-emerald-600'
							: params.value === 'prospecto' ? 'bg-orange-100 text-orange-600'
								: 'text-rose-500 bg-rose-100',
						'flex justify-center w-[130px] py-1 rounded-md uppercase font-bold'
					)}>
						<span className="text-[.8rem]">{params.value}</span>
					</div>
				</div>
			),
		},
		{
			field: 'action',
			headerName: '',
			sortable: false,
			disableColumnMenu: true,
			width: 150,
			renderCell: (params) =>
			(
				<div className='w-full flex justify-center gap-4'>
					{
						params.row.status === 'validando' && typeUserCanValidate.includes(typeUser)
							?
							(
								<Tooltip title="Validar pago del candidato" TransitionComponent={Zoom} placement='left'>
									<Link
										to={`/candidatos/${params.id}`}
										className="flex justify-center shadow-sm shadow-indigo-600 bg-indigo-600 uppercase px-4 py-2 text-slate-50 rounded hover:bg-indigo-800"
									>
										<CheckCircleIcon className="block h-5 w-5" aria-hidden="true" />
									</Link>
								</Tooltip>
							)
							: params.row.status === 'completado' || params.row.status === 'prospecto'
								?
								(
									<Tooltip title="Ver detalle del proceso" TransitionComponent={Zoom} placement='left'>
										<Link
											to={`/mostrar-candidato/${params.id}`}
											className="flex justify-center shadow-sm shadow-sky-600 bg-sky-600 px-4 py-2 uppercase text-slate-50 rounded hover:bg-sky-800"
										>
											<EyeIcon className="block h-5 w-5" aria-hidden="true" />
										</Link>
									</Tooltip>
								)
								: typeUserCanView.includes(typeUser)
									? (
										<Tooltip title="Ver detalle del proceso" TransitionComponent={Zoom} placement='left'>

											<Link
												to={`/mostrar-candidato/${params.id}`}
												className="flex justify-center shadow-sm shadow-sky-600 bg-sky-600 px-4 py-2 uppercase text-slate-50 rounded hover:bg-sky-800"
											>
												<EyeIcon className="block h-5 w-5" aria-hidden="true" />
											</Link>
										</Tooltip>
									)
									: null
					}

				</div>
			),
		},
		{
			field: 'nameUser',
			headerName: 'Nombre el usuario',
			width: 350,
			renderCell: (params) => (
				<p className='text-md'>{capitalizarPalabras(params.value)}</p>
			),
		},
		{
			field: 'email',
			headerName: 'Correo Electronico',
			width: 300,
		},
		{
			field: 'dateBirth',
			headerName: 'Fecha de nacimiento',
			width: 250,
			renderCell: (params) => (
				<p className='capitalize w-[200px] text-center bg-slate-200 px-3 py-1 rounded-md text-sm text-gray-700'>
					{formatDate(params.value)}
				</p>
			),
		},
		{
			field: 'location',
			headerName: 'Ubicacion',
			width: 250,
		},
		{
			field: 'education',
			headerName: 'Nivel educativo',
			width: 250,
		},
		{
			field: 'language',
			headerName: 'Idioma',
			width: 350,
			renderCell: (params) => {
				const languages = params.value.split(' ').map(lang => lang.trim());
				return (
					<div className='course-identifiers'>
						{
							languages.map((lang, index) => <p key={`item-${lang}-${index}`} className='text-center capitalize bg-slate-200 px-3 py-1 rounded-md text-sm text-gray-700'>{`${lang}`}</p>)
						}
					</div>
				)
			}
		},
		{
			field: 'createdAt',
			headerName: 'Fecha de solicitud',
			width: 300,
			renderCell: (params) => (
				<p className='capitalize w-[200px] text-center bg-slate-200 px-3 py-1 rounded-md text-sm text-gray-700'>
					{formatDate(params.value)}
				</p>
			),
		},
		{
			field: 'coordinador',
			headerName: 'Coordinador',
			width: 300,
			renderCell: (params) => (
				<p>{capitalizarPalabras(params.value)}</p>
			),
		},
	];

	const handleSearchChange = (e) => {
		setSearchText(e.target.value);
		// Cancelamos el timeout anterior si el usuario sigue escribiendo
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}
		// Esperamos 500ms desde el último cambio antes de ejecutar la lógica
		timeoutRef.current = setTimeout(() => {
			// ya puedes hacer fetch, actualizar estado global, etc.
			searchUserByQuery(e.target.value);
		}, 1000);
	}

	const searchUserByQuery = (query) => {
		dispatch(getAllPreRegister(
			id,
			roles,
			0,
			15,
			filterOption,
			query,
		))
			.then(((result) => {
				if (result.status === 200) {
					setpageSizeOptions({
						pageSize: result.pageSize,
						page: result.page,
						totalRows: result.totalRows
					})
				}
			}
			));
	}

	const formatDataExcel = async (data) => {
		const formattedData = data.map(item => ({
			nombre: item.firstName,
			primer_apellido: item.lastName,
			correo_electronico: item.email,
			telefono: item.phone,
			fecha_nacimiento: formatDate(item.dateBirth),
			localizacion: item.location,
			nivel_educativo: item.education,
			lenguajes: item.language,
			status: item.status,
			fecha_registro: formatDate(item.createdAt),
			cordinador: item.coordinador,
		}));
		return formattedData;
	}

	const handleImportData = async (data, name) => {
		dispatch(verifyStateApp())
			.then((response) => {
				if (response.data === false) {
					toast.error(response.message)

				} else {
					confirDownloadFile(data, name);
				}
			});
	}

	const confirDownloadFile = async (data, name) => {
		const dataReady = await formatDataExcel(data);
		const response = exportToExcel(dataReady, name);
		response.data ? toast.error(response.message) : toast.success(response.message);
	}


	return (
		<ContainerFull>
			<Heading
				title={`Lista de candidatos`}
				subtitle={`Muestra la lista candidatos con su estatus de proceso`}
				center={false}
			/>
			<div className='w-full flex justify-end mt-4 gap-4'>
				<div>
					<DropDownFilterSingle
						title={"Estatus del candidato"}
						options={optionsStatusCandidate}
						state={filterOption}
						setState={setFilterOption}
					/>
				</div>
				{/* <Tooltip title="Descargar archivo de Excel" TransitionComponent={Zoom} placement='top'>
					<button
						type='button'
						onClick={() => handleImportData(allPreRegisters, 'Lista_de_candidatos.xlsx')}
						className='rounded-md px-4 py-2 font-semibold text-md text-white bg-indigo-600 shadow-sm shadow-indigo-600 hover:bg-indigo-800'
					><DocumentArrowDownIcon className="block h-5 w-5" aria-hidden="true" /></button>
				</Tooltip> */}
			</div>

			{allPreRegisters && (
				<>
					<Wrapper>
						<input
							type="text"
							placeholder="Buscar un candidato"
							value={searchText}
							onChange={handleSearchChange}
							className='block w-full rounded-md border-0 py-2 px-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6' />
					</Wrapper>

					<Wrapper>
						<div className='overflow-x-auto'>
							{
								loading
									? (
										<Loading />
									) : (
										<>
											{
												rows.length > 0
													? (
														<DataTableCustom
															rows={rows}
															columns={columns}
															pageSizeOptions={pageSizeOptions}
															onPageChange={handlePageChange}
														/>
													) : (
														<p className='text-gray-400'>No hay registro de candidatos</p>
													)
											}
										</>
									)
							}
						</div>
					</Wrapper>
				</>
			)}
		</ContainerFull>
	);
}
